import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const postDemoRequest = createAsyncThunk(
  "contact/requestDemo",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/contact/requestdemo", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        success: false,
        result: { message: error.response?.data?.message || error.message }
      });
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    loading: false,
    contactSuccessMessage: null,
    contactErrorMessage: null,
  },
  reducers: {
    resetContactMessage: (state) => {
      state.contactSuccessMessage = null;
      state.contactErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postDemoRequest.pending, (state) => {
        state.loading = true;
        state.contactSuccessMessage = null;
        state.contactErrorMessage = null;
      })
      .addCase(postDemoRequest.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.contactErrorMessage = action.payload.result.message;
        } else {
          state.contactSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(postDemoRequest.rejected, (state, action) => {
        state.loading = false;
        state.contactErrorMessage = action.payload?.result?.message || "Server Error";
      });
  },
});

export const { resetContactMessage } = contactSlice.actions;
export default contactSlice.reducer;